import type { IconProps } from '.';

/**
 * Email Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const EmailIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 18 14"
    fill="none"
    className={className}
  >
    <path
      d="M0 0.25H18V3.0625L9 9.25L0 3.0625V0.25ZM0 13.75V4.43359L8.33203 10.1992L9 10.6211L9.63281 10.1992L18 4.43359V13.75H0Z"
      fill="white"
    />
  </svg>
);

export default EmailIcon;
